import { EnumSchema, Executor, ExecutorSchema, FromSchema, ZodDate } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { BillingEntityType } from './billing.entity-type.enum';
import { BillingStatus } from './billing.status.enum';
import { BillingType } from './billing.type.enum';

export const BillingSchema = WithBaseEntitySchema(
    z.object({
        amount: z.number(),
        currency: EnumSchema(Currency),
        note: z.string().optional(),
        status: EnumSchema(BillingStatus),
        type: EnumSchema(BillingType).optional(),
        entityType: EnumSchema(BillingEntityType),
        entitiesIds: z.array(z.string()),
        createdBy: ExecutorSchema.optional(),
        metadata: z.record(z.string()).optional(),
        timeline: z.record(z.object({ updatedAt: ZodDate })).optional(),
    }),
).strict();

export class Billing extends FromSchema(BillingSchema) implements BaseEntity {
    id: string;
    amount: number;
    currency: Currency;
    note?: string;
    status: BillingStatus;
    type?: BillingType;
    entityType: BillingEntityType;
    entitiesIds: string[];
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    createdBy?: Executor;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
    seller?: string | Seller;
}
